
import { mapState, mapMutations, mapActions } from 'vuex'
import FormField from '../_globals/forms/FormField.vue'
import DietaryFilters from './DietaryFilters.vue'
import Icon from './Icon'

export default {
  name: 'CategorySearch',
  components: {
    FormField,
    Icon,
    DietaryFilters
  },
  computed: {
    ...mapState([ 'loading', 'appInfo', 'searchedMenu', "menu", "catering" ]),
  },
  props: {
    showFilterBy: {
      type: Boolean,
      default: false,
    },
    dietaryConfig: {
      type: Object,
    },
    lifeStyleConfig: {
      type: Object,
    },
    placement: {
      type: String,
      default: 'menu',
      validator: (value) => {
        return ['menu', 'catering', 'order'].includes(value)
      }
    },
  },
  data() {
    return {
      timeout: null,
      query: '',
      dietaryFilters: [],
      lifeStyleFilters: [],
    }
  },
  methods: {
    ...mapMutations({
      setAddress: 'locations/setAddress'
    }),
    ...mapActions([ 'filterMenu' ]),
    debounce() {
      if (this.query && this.query.length < 3) return

      if (this.timeout) {
        clearTimeout(this.timeout)
      }

      this.timeout = setTimeout(() => {
        this.filterMenu({ 
          searchTerm: this.query, 
          placement: this.placement,
          lifeStyleFilters: this.lifeStyleFilters,
          dietaryFilters: this.dietaryFilters,
        });
      }, 300);
    },
    submitAddressSearch() {
      this.filterMenu({ 
        searchTerm: this.query, 
        placement: this.placement,
        lifeStyleFilters: this.lifeStyleFilters,
        dietaryFilters: this.dietaryFilters,
      });
    },
    updateDietaryFilters(filters) {
      this.dietaryFilters = filters;
      this.applyFilters();
    },
    updateLifeStyleFilters(filters) {
      this.lifeStyleFilters = filters;
      this.applyFilters();
    },
    applyFilters() {
      this.filterMenu({
        searchTerm: this.query,
        placement: this.placement,
        lifeStyleFilters: this.lifeStyleFilters,
        dietaryFilters: this.dietaryFilters,
      });
    },
  },
}
